import { Tabs } from '@studiometa/ui';

/**
 * HeroTabs component
 */
export default class HeroTabs extends Tabs {
  /**
   * Component Configuration
   */
  static config = {
    name: 'HeroTabs',
    refs: [...Tabs.config.refs, 'media[]'],
  };

  /**
   *
   */
  mounted() {
    super.mounted();

    this.$refs.media.forEach((media) => {
      if (media instanceof HTMLVideoElement) {
        media.pause();
      }
    });
  }

  /**
   * onBtnClick
   * @param {number} index
   */
  onBtnClick({ index }) {
    if (this.$refs.media[index] instanceof HTMLVideoElement) {
      if (this.$refs.media[index]) {
        this.$refs.media[index].currentTime = 0;
        this.$refs.media[index].play();
      } else {
        this.$refs.media[index].pause();
      }
    }

    super.onBtnClick({ index });
  }
}
